import { gsap } from "gsap";
import { BenMarcPaths } from "./const";

function getLength(pathData) {
    const path = document.createElementNS("http://www.w3.org/2000/svg", "path");
    path.setAttribute("d", pathData)
    return path.getTotalLength() || 0;
}

export default class BenMarcLogo {
    constructor(width, height, delay = 0) {
        this.width = width;
        this.height = height;
        this.delay = delay;
        this.speed = 0.3;
        this.letterDelay = 0.05;
        this.init();
    }

    init() {
        this.initSettings()
        this.initCanvas()
        this.drawCurves()
    }

    drawCurves() {
        this.context.fillStyle = '#000000';
        this.context.fillRect(0, 0, this.width, this.height);
        this.context.strokeStyle = '#FFFFFF';
        this.paths.forEach((path, index) => {
            this.drawCurve(path, index);
        })
    }

    drawCurve(curve, index) {
        const delay = index * this.letterDelay + this.delay;
        const path = {}
        path.data = curve;
        path.width = path.data.width;
        path.path2d = new Path2D(path.data.path);
        path.length = getLength(path.data.path);
        path.offset = path.length;

        gsap.to(path, {
            duration: this.speed,
            offset: 0,
            ease: 'power1.inOut',
            delay: delay,
            onUpdate: () => {
                this.drawPath(path.path2d, path.length, path.offset, path.width);
            }
        })
    }

    drawPath(path, length, offset, width = 1) {
        this.context.save();
        this.context.lineWidth = width;
        this.context.setLineDash([length - offset, offset]);
        this.context.stroke(path);
        this.context.restore();
    }

    initSettings() {
        this.paths = BenMarcPaths;
    }

    initCanvas() {
        this.canvas = document.createElement('canvas');
        this.context = this.canvas.getContext('2d');
        this.canvas.width = this.width;
        this.canvas.height = this.height;
    }
}
